import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
  min-width: 0;
`;

export const PriceHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const Eyebrow = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const FromPriceRow = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${space['space-100']};
`;

export const PerPlayer = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const PlayerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${space['space-300']};
  padding: ${space['space-400']} 0;
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.subtle};
`;

export const PlayerLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const PlayerControl = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${space['space-400']};
`;

export const LimitNote = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const CalendarSection = styled.div`
  padding-top: ${space['space-400']};
`;

export const OptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  padding-top: ${space['space-400']};
`;

export const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space['space-200']};
`;
